import { render, staticRenderFns } from "./print_header.vue?vue&type=template&id=36bab876&scoped=true"
import script from "./print_header.vue?vue&type=script&lang=js"
export * from "./print_header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bab876",
  null
  
)

export default component.exports